import { InputWithLabel } from '@adotel/components'
import { Button, Paper, Slide, Typography } from '@material-ui/core'
import List from '@material-ui/core/List/List'
import Modal from '@material-ui/core/Modal/Modal'
import EditIcon from '@material-ui/icons/Edit'
import SearchIcon from '@material-ui/icons/Search'
import { matchSorter } from 'match-sorter'
import { useEffect, useState } from 'react'

import { getDirection, getTranslate } from '../../localization'
import {
  RatePlanDeatials,
  RatePlanForPMSMappingList
} from '../../types/accommodationPMSMapping'
import RatePlansSelectionModalRow from './RatePlansSelectionModalRow'
import { useStyles } from './styles/RatePlansSelectionModal.styles'

interface RatePlansSelectionModalProps {
  isOpen: boolean
  onClose: () => void
  allRatePlans: RatePlanForPMSMappingList[]
  data: RatePlanForPMSMappingList[]
  setData: (data: RatePlanForPMSMappingList[]) => void
  onRatePlansChange: (
    AdotelCode: string,
    rateplans: RatePlanForPMSMappingList[],
    updatedRateplans: RatePlanDeatials[]
  ) => void
  adotelCodeForRoomtype: string
}

const RatePlansSelectionModal: React.FC<RatePlansSelectionModalProps> = ({
  isOpen,
  onClose,
  allRatePlans,
  data,
  setData,
  onRatePlansChange,
  adotelCodeForRoomtype
}) => {
  const classes = useStyles()
  const [selectedRateplan, setSelectedRateplan] = useState<string>(
    data.find((item) => item.PMSCode === 'NoData')?.AdotelCode || ''
  )
  useEffect(() => {
    setSelectedRateplan(
      data.find((item) => item.PMSCode === 'NoData')?.AdotelCode || ''
    )
  }, [data])

  const [searchInput, setSearchInput] = useState<string>('')
  const filterRatePlans = (inputValue: string) => {
    const ans = matchSorter(allRatePlans, inputValue, {
      keys: ['AdotelName', 'AdotelCode']
    })
    return ans
  }

  useEffect(() => {
    const indexOfSelected = data.findIndex(
      (s) => s.AdotelCode === selectedRateplan
    )

    if (indexOfSelected > -1)
      setData([
        ...data
          .slice(0, indexOfSelected)
          .map((item) => ({ ...item, PMSCode: null })),
        { ...data[indexOfSelected], PMSCode: 'NoData' },
        ...data
          .slice(indexOfSelected + 1)
          .map((item) => ({ ...item, PMSCode: null }))
      ])
  }, [selectedRateplan])

  useEffect(() => {
    if (onRatePlansChange) {
      onRatePlansChange(adotelCodeForRoomtype, data, [])
    }
  }, [selectedRateplan, data])

  return (
    <Modal
      open={isOpen}
      className={classes.modal}
      dir={getDirection()}
      onClose={onClose}>
      <Slide direction="down" in={isOpen}>
        <Paper className={classes.ratePlansPaper}>
          <EditIcon className={classes.editIcon} />
          <div className={classes.title}>
            <Typography variant="h3">{getTranslate('RatePlans')}</Typography>
          </div>
          <div className={classes.inputWithLabel}>
            <InputWithLabel
              startIcon={<SearchIcon />}
              noHelperText
              placeholder={getTranslate('Search in RatePlans names & codes')}
              onChange={(event) => setSearchInput(event.currentTarget.value)}
            />
          </div>
          <div>
            <List>
              {filterRatePlans(searchInput).map((item, index) => (
                <RatePlansSelectionModalRow
                  key={index}
                  selectedRateplan={selectedRateplan}
                  AdotelCode={item.AdotelCode}
                  AdotelName={item.AdotelName}
                  disabled={!item.Active}
                  onClick={() => {
                    setSelectedRateplan(item.AdotelCode)
                  }}
                />
              ))}
            </List>
          </div>
          {selectedRateplan === '' && (
            <Typography color="error">
              {getTranslate('You must select at least one rateplan .')}
            </Typography>
          )}
          <div className={classes.buttonsStyles}>
            <Button onClick={onClose} variant="text" color="primary">
              {getTranslate('Close')}
            </Button>
            <Button
              className={classes.saveButton}
              variant="contained"
              onClick={() => {
                onClose()
              }}
              color="primary">
              {getTranslate('Save')}
            </Button>
          </div>
        </Paper>
      </Slide>
    </Modal>
  )
}
export default RatePlansSelectionModal
